import { render, staticRenderFns } from "./TKInsuranceTable.vue?vue&type=template&id=37a57978&"
import script from "./TKInsuranceTable.vue?vue&type=script&lang=js&"
export * from "./TKInsuranceTable.vue?vue&type=script&lang=js&"
import style0 from "./TKInsuranceTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!F:/yicai/wanhuahengxin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib'
installComponents(component, {VDataTable})
